import React, { useContext } from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { TooltipProps, TooltipProviderProps } from './Tooltip.types'
import { TooltipContent, TooltipTrigger } from './Tooltip.styles'

const DEFAULT_DELAY = 1000

const TooltipGroupContext = React.createContext(false)

export const TooltipProvider: React.FC<TooltipProviderProps> = ({
  children,
  delay = DEFAULT_DELAY,
}) => {
  const alreadyGrouped = useContext(TooltipGroupContext)
  if (alreadyGrouped) return <>{children}</>

  return (
    <TooltipGroupContext.Provider value={true}>
      <TooltipPrimitive.Provider
        delayDuration={delay}
        skipDelayDuration={delay}
        disableHoverableContent
      >
        {children}
      </TooltipPrimitive.Provider>
    </TooltipGroupContext.Provider>
  )
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  placement = 'top',
  delay = DEFAULT_DELAY,
  maxWidth = 250,
}) => {
  const inGroup = useContext(TooltipGroupContext)

  if (!content) return <>{children}</>

  const tooltip = (
    <TooltipPrimitive.Root delayDuration={delay}>
      <TooltipPrimitive.Trigger asChild>
        <TooltipTrigger>{children}</TooltipTrigger>
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipContent side={placement} sideOffset={8} collisionPadding={8} $maxWidth={maxWidth}>
          {content}
        </TooltipContent>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )

  if (inGroup) return tooltip

  return (
    <TooltipPrimitive.Provider
      delayDuration={delay}
      skipDelayDuration={delay}
      disableHoverableContent
    >
      {tooltip}
    </TooltipPrimitive.Provider>
  )
}
